<div class="sidebar">
  <div class="webtree pointer" (click)="goToDefault()">
    <img src="../assets/images/webtree.png" alt="">
  </div>
  <nav>
    <ul class="nav flex-column">
      <!-- <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isSearchActive}">
        <a data-testid="auto-app-sidebar-a-1" class="nav-link" (click)="Route2ToolBox('version1.0')" >
          <i class="fab fa-searchengin f-16"></i>
          <span class="menulist">Search Toolbox</span>
        </a>
      </li> -->
      <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isPersonSearchActive}">
        <a data-testid="auto-app-sidebar-a-2" class="nav-link" routerLink="/search" (click)="getCleverTapEvents('Person Search')">
          <i class="fa-solid fa-user-magnifying-glass"></i>
          <span class="menulist">Search</span>
        </a>
      </li>

        <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isAiSourcingActive}">
          <a data-testid="auto-app-sidebar-a-3" class="nav-link ai-sourcing-img" routerLink="/ai-sourcing" (click)="getCleverTapEvents('Ai Sourcing')">
            <img style="width: 31px; height: 31px; padding: 0px;" src="../../assets/ai-sourcing/webbtree_sidebar.svg" alt="ai_sourcing">
            <span class="menulist mr-3">Autopilot<sup class="" style="top: 4px!important;"><span>AI</span></sup><span class="f-10 font-weight-500 beta ml-2" style="color: black;">New</span></span>
          </a>
        </li>

          <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isProjectsActive}">
            <a data-testid="auto-app-sidebar-a-4" class="nav-link ai-sourcing-img" routerLink="/projects" (click)="getCleverTapEvents('Projects')">
              <img style="width: 31px; height: 31px; padding: 0px;" src="../../assets/ai-sourcing/webbtree_sidebar.svg"
                alt="ai_sourcing">
              <span class="menulist mr-3">Projects</span>
            </a>
          </li>

        <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': atsResumeScreeningActive}">
          <a data-testid="auto-app-sidebar-a-5" class="nav-link ai-sourcing-img" routerLink="/resume-screen" (click)="getCleverTapEvents('resume-screen')">
            <img [ngStyle]="atsResumeScreeningActive ? { width: '31px', height: '31px',padding: '4px' } : {width: '31px', height: '31px',padding: '4px'}" src="../../assets/ai-sourcing/screenai.svg"
              alt="ai_sourcing">
            <span class="menulist mr-3">Screen AI</span>
          </a>
        </li>


      <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isActive}">
        <a data-testid="auto-app-sidebar-a-6" class="nav-link " routerLink="/talent/talentpool" (click)="getCleverTapEvents('Talent pool')">
          <i class="fas fa-users"></i>
          <span class="menulist">Talent pools</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isCompanyPagesActive}">
        <a data-testid="auto-app-sidebar-a-7" class="nav-link position-relative" routerLink="/webbtree-company-list">
          <!-- <span class="position-relative"> -->
          <!-- <i class="fa-solid fa-chart-pie-simple-circle-currency"></i> -->
          <i class="fa-solid fa-building"></i>
          <i class="fa-solid fa-chart-mixed icon2"></i>
        <!-- </span> -->
        <!-- <img style="width: 28px; height: 28px; padding: 2px;" src="../../assets/insight-icon.svg" alt="company-insights"> -->
          <span class="menulist">Company Insights</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isTalentpoolInsightPagesActive}">
        <a data-testid="auto-app-sidebar-a-8" class="nav-link" routerLink="/talentpool-insights" (click)="getCleverTapEvents('Talent Insights')">
          <img src="../../assets/images/talent-isights-icon.png" alt="" class="talent-insight-img" srcset="">
          <span class="menulist">Talent Insights</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isSearchToolboxV2Active}">
        <a data-testid="auto-app-sidebar-a-9" class="nav-link" (click)="Route2ToolBox('version2.0')" (click)="getCleverTapEvents('Toolbox')">
          <!-- <i class="fab fa-searchengin f-16"></i> -->
          <i class="fa-solid fa-toolbox f-16"></i>
          <span class="menulist">Toolbox</span>
        </a>
      </li>
      <!-- commented email campaign -->
      <li *ngFor="let nv of navModules" class="nav-item" [routerLinkActive]="nv.activeClass">
        <a data-testid="auto-app-sidebar-a-10" class="nav-link position-relative"  [routerLink]="nv.route" (click)="getCleverTapEvents('Email Campaign')">
          <i class="fa-solid f-16" [ngClass]="nv.icon"></i>
          <span class="menulist">{{ nv.name }}</span>
        </a>
      </li>

      <!-- <li class="nav-item" routerLinkActive="active">
        <a data-testid="auto-app-sidebar-a-11" class="nav-link" routerLink="/reports">
          <i class="fa-solid fa-search"></i>
          <span class="menulist">Reports</span>
        </a>
      </li> -->

      <li class="nav-item" routerLinkActive="active">
        <a data-testid="auto-app-sidebar-a-12" class="nav-link " routerLink="/reports/personal-reports" (click)="getCleverTapEvents('Reports')">
          <i class="fa-solid fa-file-chart-column f-16"></i>
          <span class="menulist">Reports</span>
        </a>
      </li>

      <!-- <li class="nav-item" routerLinkActive="active">
        <a data-testid="auto-app-sidebar-a-13" class="nav-link " routerLink="/old-settings">
          <i class="fas fa-cog f-16"></i>
          <span class="menulist">Settings</span>
        </a>
      </li> -->

      <li class="nav-item" routerLinkActive="active">
        <a data-testid="auto-app-sidebar-a-14" class="nav-link " routerLink="/settings" (click)="getCleverTapEvents('Settings')">
          <i class="fas fa-cog f-16"></i>
          <span class="menulist">Settings</span>
        </a>
      </li>

      <!-- <li class="nav-item" routerLinkActive="active" [ngClass]="{'active': isCompanyPagesActive}">
        <a data-testid="auto-app-sidebar-a-15" class="nav-link" routerLink="/companypage" >
          <i class="fa-solid fa-chart-pie-simple-circle-currency"></i>
          <span class="menulist">Company Insights</span>
        </a>
      </li>

      <li class="nav-item" routerLinkActive="active">
        <a data-testid="auto-app-sidebar-a-16" class="nav-link" routerLink="/talentpool-insights" >
          <i class="fa-solid fa-search"></i>
          <span class="menulist">Talent Insights</span>
        </a>
      </li> -->


    </ul>
  </nav>
</div>
